import './App.css';
import Hero from './Hero/Hero';
import Main from './Main/Main';
import Footer from './Footer/Footer'

function App() {
  return (
    <div className="App">
      <Hero />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
